// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"NK0yY"};